import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { colors } from '../theme';

interface TopNavProps {
  title?: string;
  showBack?: boolean;
}

export default function TopNav({ title, showBack }: TopNavProps) {
  const { user, profile } = useAuth();
  const navigate = useNavigate();

  const initial = (profile?.displayName || user?.displayName || user?.email || '?').charAt(0).toUpperCase();

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        background: colors.background,
        borderBottom: `1px solid ${colors.divider}`,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 16px',
        minHeight: 56,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            style={{
              background: 'none',
              border: 'none',
              color: colors.primary,
              fontSize: 24,
              cursor: 'pointer',
              padding: '0 8px 0 0',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ‹
          </button>
        )}
        <img
          src="/logo-white.png"
          alt="SageTech"
          style={{ height: 32, objectFit: 'contain', cursor: 'pointer' }}
          onClick={() => navigate('/home')}
        />
        {title && (
          <span
            style={{
              color: colors.textSecondary,
              fontSize: 14,
              marginLeft: 8,
            }}
          >
            {title}
          </span>
        )}
      </div>

      {user && (
        <button
          onClick={() => navigate('/profile')}
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: `linear-gradient(135deg, #E040A0, #7B2FBE)`,
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff', // avatar text stays white on gradient bg
            fontWeight: 700,
            fontSize: 16,
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          }}
        >
          {initial}
        </button>
      )}
    </header>
  );
}
